import { render, staticRenderFns } from "./GridDrmSettings.vue?vue&type=template&id=4a013d80&scoped=true&"
import script from "./GridDrmSettings.vue?vue&type=script&lang=ts&"
export * from "./GridDrmSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GridDrmSettings.vue?vue&type=style&index=0&id=4a013d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a013d80",
  null
  
)

export default component.exports